"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _snackbarActions = require("../../redux/actions/snackbarActions");
var _APSnackbar = _interopRequireDefault(require("../common/APSnackbar/APSnackbar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    snacks: state.snackbar.snacks
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dismissSnackByUniqueId: function dismissSnackByUniqueId(payload) {
      return dispatch((0, _snackbarActions.dismissSnack)(payload));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_APSnackbar["default"]);